import { useEffect, useMemo, useRef } from "react";

// eslint-disable-next-line import/no-named-default
import { default as PassiveSection } from "../../components/shared/EntriesGenerator/Section/Section/Section";
import { type ISection } from "../../interfaces";
import { useSelector } from "../../redux/hooks";
// eslint-disable-next-line import/no-named-default
import { default as ClassicSection } from "../PortraitOrientation/PortraitSection/PortraitSection";

interface Props {
  sectionIndex: number;
  sections?: ISection[];
}

const LogbookOverlay = ({
  sectionIndex,
  sections: overwriteSections,
}: Props) => {
  const { sections: stateSections } = useSelector(
    state => state.generatorSlice.lbentry,
  );

  const sectionRef = useRef<Element | null>(null); // Create a ref for the section element
  const overlaySectionRef = useRef<HTMLDivElement | null>(null); // Create a ref for the section element

  const sections = useMemo(
    () => overwriteSections ?? stateSections,
    [overwriteSections, stateSections],
  );

  const minimizedSection: ISection | null = useMemo(
    () =>
      overwriteSections
        ? overwriteSections[sectionIndex]
        : sectionIndex !== -1 && sections?.[sectionIndex]
          ? {
              ...sections[sectionIndex],
              rows: [sections[sectionIndex].rows[0]],
            }
          : null,
    [sections, sectionIndex],
  );

  useEffect(() => {
    if (!minimizedSection || sectionIndex === -1) return;

    const { className } = minimizedSection;
    const sectionEl = document.querySelector(`.${className}_scroll`);

    sectionRef.current = sectionEl ?? null;

    const handleHorizontalScroll = () => {
      if (sectionRef.current) {
        const elScrollX = sectionRef.current.scrollLeft;
        overlaySectionRef.current?.scrollTo({ left: elScrollX });
      }
    };
    handleHorizontalScroll();
    sectionEl?.addEventListener("scroll", handleHorizontalScroll);
    return () => {
      sectionEl?.removeEventListener("scroll", handleHorizontalScroll);
    };
  }, [minimizedSection, sectionIndex, sectionRef, overlaySectionRef]);

  return (
    <div
      style={{
        position: "sticky",
        top: -20,
        zIndex: 2,
        pointerEvents: "none",
        height: 0,
      }}>
      <div
        style={{
          position: "relative",
          top: "-100%",
        }}>
        {minimizedSection && !overwriteSections && (
          <ClassicSection
            sectionIndex={sectionIndex}
            {...{ ...minimizedSection, className: "" }}
            isOverlay={true}
            ref={overlaySectionRef}
          />
        )}
        {minimizedSection && overwriteSections && (
          <PassiveSection
            section={minimizedSection}
            horizontalScroll={true}
            isOverlay={true}
            sIndex={sectionIndex}
            ref={overlaySectionRef}
          />
        )}
      </div>
    </div>
  );
};
export default LogbookOverlay;
